var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13125 2.49062H7.50062V0.105625C7.26437 0.073125 6.45187 0 5.50562 0C3.53125 0 2.17875 1.24187 2.17875 3.52437V5.625H0V8.29125H2.17875V15H4.85V8.29187H6.94062L7.2725 5.62563H4.84937V3.78875C4.85 3.01812 5.0575 2.49062 6.13125 2.49062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbFoot);
export default __webpack_public_path__ + "static/media/fb-foot.f302335a3de5bf4853130adf662d3712.svg";
export { ForwardRef as ReactComponent };